import { Base } from '@studiometa/js-toolkit';

/**
 * Panel Class.
 */
export default class Panel extends Base {
  isOpen = false;

  static config = {
    name: 'Panel',
    refs: ['close[]', 'panel', 'overlay', 'content', 'title'],
    emits: ['close-panel'],
  };

  /**
   * Close when press Escape key
   * @param  {object} options key
   * @param  {object} options.ESC key
   * @returns {void}
   */
  keyed({ ESC }) {
    if (ESC) {
      this.closePanel();
    }
  }

  /**
   * Close on click
   * @returns {void}
   */
  onCloseClick() {
    this.closePanel();
  }

  /**
   * Close on click
   * @returns {void}
   */
  onOverlayClick() {
    this.closePanel();
  }

  /**
   * Show Popin
   * @returns {void}
   */
  openPanel() {
    this.isOpen = true;
    document.body.classList.add('overflow-hidden');
    this.$el.classList.remove('hidden');
    document.body.classList.add('is-panel-open');
    this.$el.classList.remove('pointer-events-none');
    this.$refs.overlay.classList.remove('opacity-0');
    this.$refs.panel.classList.remove('translate-x-full', 'pointer-events-none');
  }

  /**
   * Close popin
   * @returns {void}
   */
  closePanel() {
    this.isOpen = false;
    this.$emit('close-panel');
    document.body.classList.remove('overflow-hidden');
    this.$refs.overlay.classList.add('opacity-0');
    this.$refs.panel.classList.remove('pointer-events-none');
    this.$refs.panel.classList.add('translate-x-full');
    this.$el.classList.add('pointer-events-none');
    setTimeout(() => {
      document.body.classList.remove('is-panel-open');
    }, 300);
  }

  /**
   * Set content before opening Panel
   * @param {string} selector
   * @param {string} title
   * @returns {void}
   */
  setContent(selector, title) {
    this.content = document.querySelector(selector).innerHTML;
    this.$refs.title.innerHTML = title;
    this.$refs.content.innerHTML = this.content;
    this.openPanel();
  }
}
